<template>
  <div>
    <div v-show="!showdetail">
      <div>
        <search
          @opout="opsearch"
          :searchdata="searchcontent"
          v-model="searchcontent"
        ></search>
      </div>
      <div>
        <el-container>
          <el-aside width="280px">
            <div style="height: 80%; margin-top: 10%; margin-bottom: 10%">
              <mytree
                @pushdata="gettreefilter"
                :treefilter="treecontent"
                v-model="treecontent"
              ></mytree>
            </div>
          </el-aside>
          <el-main>
            <el-card class="box-card">
              <div v-show="show">
                <div style="font-size: 24px">数据拉取中</div>
                <div>
                  <img src="/wait.gif" width="100%" />
                </div>
              </div>
              <div v-show="!show">
                <el-table
                  v-loading="loading"
                  element-loading-text="拼命加载中"
                  element-loading-spinner="el-icon-loading"
                  element-loading-background="rgba(0, 0, 0, 0.8)"
                  :data="tableData"
                  border
                  style="width: 100%"
                  max-height="600"
                  @row-dblclick="rowdbclk"
                >
                  <el-table-column
                    header-align="center"
                    prop="_source.skuisbn"
                    label="ISBN"
                    width="150"
                    v-if="true"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    prop="_source.skuno"
                    label="书号"
                    width="120"
                    v-if="false"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    prop="_source.skuname"
                    label="书名"
                    width="280"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    prop="_source.sauthor"
                    label="作者"
                    width="120"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="right"
                    prop="_source.ssprice"
                    label="价格"
                    width="60"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    prop="_source.spubname"
                    label="版别"
                    width="160"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="_source.spubdate"
                    label="出版日期"
                    width="100"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    prop="_source.tsmc"
                    label="套书名"
                    width="320"
                    v-if="false"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    prop="_source.sztflm"
                    label="中图分类码"
                    width="120"
                    v-if="false"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    prop="_source.dlmc"
                    label="大类名称"
                    width="160"
                    v-if="false"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    prop="_source.dldm"
                    label=""
                    width="60"
                    v-if="false"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    prop="_source.zlmc"
                    label="中类名称"
                    width="160"
                    v-if="false"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    prop="_source.zldm"
                    label=""
                    width="60"
                    v-if="false"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    prop="_source.xlmc"
                    label="小类名称"
                    width="160"
                    v-if="false"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    prop="_source.xldm"
                    label=""
                    width="60"
                    v-if="false"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    prop="_source.skukey"
                    label="关键字"
                    width="320"
                    v-if="false"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="right"
                    prop="_source.skupagetotal"
                    label="总页数"
                    width="80"
                    v-if="false"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    prop="_source.skucontent"
                    label="内容简介"
                    width="1200"
                    v-if="false"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    prop="_source.sauthorlife"
                    label="作者生平"
                    width="1200"
                    v-if="false"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="_source.supdateDate"
                    label="更新日期"
                    width="200"
                    v-if="false"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="right"
                    prop="_source.isckc"
                    label="库存"
                    width="50"
                    v-if="true"
                  ></el-table-column>

                  <el-table-column fixed="right" label="操作" width="100">
                    <template slot-scope="scope">
                      <el-button
                        @click="showskudetail(scope.row)"
                        type="text"
                        size="small"
                        >商品详情</el-button
                      >
                      <div>
                        <!-- <div class="el-button" @click="putcart(scope.row._source, $event)">
                      放购物车
                    </div> -->
                        <el-button
                          @click="putcart(scope.row._source, $event)"
                          type="text"
                          size="small"
                          >放购物车</el-button
                        >
                      </div>
                    </template>
                  </el-table-column>
                </el-table>

                <div class="block" style="display: flex; margin-top: 20px; ">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="stooltip"
                    placement="bottom"
                  >
                    <span class="demonstration"></span>
                    <el-pagination
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChange"
                      :current-page="ipageindex"
                      :page-size="ipagesize"
                      :page-sizes="[5, 10, 15, 20, 30, 50, 100, 200, 1000]"
                      layout="total, sizes, prev, pager, next, jumper"
                      :total="iresultcount"
                    ></el-pagination>
                  </el-tooltip>
                  <el-button size="mini" style="height: 27px; margin-top: 2px; margin-left: 60px;font-size: 10px" @click="onmyexport()">导出EXCEL </el-button>
                </div>
              </div>
            </el-card>
          </el-main>
        </el-container>
      </div>
    </div>

    <div v-if="showdetail">
      <div style="text-align: left">
        <el-button
          type="primary"
          plain
          @click="gomain()"
          style="font-size: 16px"
          >返回</el-button
        >
      </div>
      <div>
        <skudetail
          :skupackobj="skuobj"
          @skudetailoutputparamA="getskudetailparamA"
        ></skudetail>
      </div>
    </div>
  </div>
</template>

<script>
import search from "@/components/search.vue";
import mytree from "@/components/mytree.vue";
import skudetail from "@/components/skudetail.vue";
import axios from "axios";
import Qs from "qs";
import global from "../global.vue";
import AES from "../AES.js";
import XLSX from "xlsx";

export default {
  props: ["sscope"],
  name: "xkfl",
  data() {
    return {
      loading: false,
      show: false,
      showdetail: false,
      scope: 0,
      searchcontent: {},
      treecontent: [{}],
      ipagesize: 20,
      ipageindex: 1,
      iresultcount: 0,
      tableData: [{}],
      stooltip: "",
      skuobj: {},
      sexceldownfilename: "skulist.xlsx",
    };
  },
  created() {
    this.getParams();
    this.getdata();
  },
  
  components: {
    search,
    mytree,
    skudetail,
  },
  methods: {
    onmyexport: function () {
      let tableDataExcel = [
        //["书号", "书名"], //导出表头
//        ["ISBN", "书号", "书名", "作者", "价格", "版别", "出版日期", "套书名", "中图分类码", "大类名称", "中类名称", "小类名称", "关键字", "总页数", "内容简介", "作者生平", "更新日期", "库存"], //导出表头        
        // ["书号", "书名", "作者", "价格", "出版社", "出版日期", "库存"], //导出表头        
        ["书号", "书名", "作者", "价格", "出版社", "出版日期"], //导出表头        
      ]; // 表格表头

      this.tableData.forEach((item, index) => {
        let rowData = [];
        //导出内容的字段
        //rowData = [item._source.skuno, item._source.skuname];
//        rowData = [item._source.skuisbn,item._source.skuno,item._source.skuname,item._source.sauthor,item._source.ssprice,item._source.spubname,item._source.spubdate,item._source.tsmc,item._source.sztflm,item._source.dlmc,item._source.zlmc,item._source.xlmc,item._source.skukey,item._source.skupagetotal,item._source.skucontent,item._source.sauthorlife,item._source.supdateDate,item._source.isckc];        tableDataExcel.push(rowData);
        // rowData = [item._source.skuisbn,item._source.skuname,item._source.sauthor,item._source.ssprice,item._source.spubname,item._source.spubdate,item._source.isckc];        tableDataExcel.push(rowData);
        rowData = [item._source.skuisbn,item._source.skuname,
        item._source.sauthor,
        item._source.ssprice,
        item._source.spubname,
        item._source.spubdate];
        tableDataExcel.push(rowData);
      });

      //根据传参jdata和sfilename输出
      var wsname = "skulistdata";
      var ws = XLSX.utils.aoa_to_sheet(tableDataExcel);
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, wsname);
      XLSX.writeFile(wb, this.sexceldownfilename);
    },

    gomain() {
      this.showdetail = false;
    },
    getskudetailparamA(msg) {
      // this.showdetail = msg;
    },
    
    getParams() {
      // this.scope = this.$route.query.scope;

      this.scope = this.$route.params.sscope;
    },
    putcart(row, btn) {
      this.$message({
        showClose: true,
        message: row.skuname + "正在添加到购物车",
        type: "success",
      });

      global.putchartifnull(row);
    },

    handleSizeChange(val) {
      this.ipagesize = val;
      this.getdata();
    },
    handleCurrentChange(val) {
      this.ipageindex = val;
      this.getdata();
    },
    showskudetail(row) {
      this.skuobj = row._source;
      this.showdetail = true;

      // this.$router.push({
      //   path: "/qtindex/skudetail",
      //   query: { osku: row._source },
      // });
    },
    getsearchdata(data) {
      this.searchcontent = data;
    },
    opsearch(data) {
      this.searchcontent = data;
      this.ipageindex = 1;
      //执行搜索操作
      this.getdata();
    },
    gettreefilter(data) {
      this.treecontent = data;
    },
    rowdbclk() {},
    getdata() {
      // var str = window.localStorage.getItem("douttime");
      // var douttimedec = AES.decrypt(str, global.AEScode);
      // console.log(douttimedec);
      // if (typeof douttimedec == "undefined") {
      //   alert("认证超时过期，或未认证");
      //   this.$router.replace("/");
      // } else {
      //   var myDate = new Date();
      //   if (douttimedec > myDate) {
      this.show = true;

      var arraylength = this.treecontent.length;
      var i = 0;
      var treefilter = "";
      var treenode = "";
      var treeclass = "";
      var treecode = "";
      var levelclass = "";
      for (i = 0; i < arraylength; i++) {
        treenode = this.treecontent[i];
        treenode = treenode.toString();
        treeclass = treenode.substring(0, 2);
        treecode = treenode.substring(3, this.treecontent[i].length);

        switch (treeclass) {
          case "00":
            levelclass = "dldm";
            break;
          case "01":
            levelclass = "zldm";
            break;
          case "02":
            levelclass = "xldm";
            break;
          default:
            levelclass = "";
        }

        if (levelclass == "") {
          // 选择全部，或数据有问题
          treefilter = "";
          break;
        } else {
          if (treefilter == "") {
          } else {
            treefilter = treefilter + ",";
          }
          treefilter =
            treefilter +
            '{ "term": { "' +
            levelclass +
            '": "' +
            treecode +
            '"}}';
        }
      }
      if (treefilter == "") {
      } else {
        treefilter = ' { "bool": { "should": [' + treefilter + "] } }";
      }

      var searchfilter = "";

      if (this.searchcontent.selectkind == "1") {
        if (this.searchcontent.searchtext == "") {
          //这里应该取畅销书或最近的书。
          //this.searchcontent.searchtext = "软件质量管理实践";
        } else {
          searchfilter =
            '{"bool": {"should": [' +
            '  { "wildcard": { "skuname.keyword": "*' +
            this.searchcontent.searchtext +
            '*"}} ' +
            ', { "wildcard": { "sauthor.keyword": "*' +
            this.searchcontent.searchtext +
            '*"}} ' +
            ', { "wildcard": { "spubname.keyword": "*' +
            this.searchcontent.searchtext +
            '*"}} ' +
            ', { "wildcard": { "skuno.keyword": "*' +
            this.searchcontent.searchtext +
            '*"}} ' +
            // ', { "wildcard": { "skucontent.keyword": "*' +
            // this.searchcontent.searchtext +
            // '*"}} ' +
            // ', { "wildcard": { "sauthorlife.keyword": "*' +
            // this.searchcontent.searchtext +
            // '*"}} ' +
            "] } } ";
        }
      } else if (this.searchcontent.selectkind == "2") {
        if (this.searchcontent.searchskuname == "") {
        } else {
          searchfilter = global.addcommawhennotnull(searchfilter);
          searchfilter =
            searchfilter +
            '{ "wildcard": { "skuname.keyword": "*' +
            this.searchcontent.searchskuname +
            '*"}}';
        }

        if (this.searchcontent.searchskuisbn == "") {
        } else {
          searchfilter = global.addcommawhennotnull(searchfilter);
          searchfilter =
            searchfilter +
            '{ "wildcard": { "skuno.keyword": "*' +
            this.searchcontent.searchskuisbn +
            '*"}}';
        }

        if (this.searchcontent.searchskuauthor == "") {
        } else {
          searchfilter = global.addcommawhennotnull(searchfilter);
          searchfilter =
            searchfilter +
            '{ "wildcard": { "sauthor.keyword": "*' +
            this.searchcontent.searchskuauthor +
            '*"}}';
        }

        if (this.searchcontent.searchskupublisher == "") {
        } else {
          searchfilter = global.addcommawhennotnull(searchfilter);
          searchfilter =
            searchfilter +
            '{ "wildcard": { "spubname.keyword": "*' +
            this.searchcontent.searchskupublisher +
            '*"}}';
        }

        var sbegindate = "";
        var senddaate = "";

        if (this.searchcontent.searchskupubdatebegin == "") {
        } else {
          sbegindate = '"gte": ' + this.searchcontent.searchskupubdatebegin;
        }

        if (this.searchcontent.searchskupubdateend == "") {
        } else {
          senddaate = '"lte": ' + this.searchcontent.searchskupubdateend;
        }

        var spubdatefilter = "";
        if (sbegindate == "" && senddaate == "") {
          spubdatefilter = '{ "range": { "ipubdate": {"lte": 20231231  }}  } ';
        } else if (sbegindate == "" && senddaate != "") {
          spubdatefilter = spubdatefilter =
            '{ "range": { "ipubdate": {' + senddaate + "  }}  } ";
        } else if (sbegindate != "" && senddaate == "") {
          spubdatefilter = spubdatefilter =
            '{ "range": { "ipubdate": {' + sbegindate + "  }}  } ";
        } else if (sbegindate != "" && senddaate != "") {
          spubdatefilter = spubdatefilter =
            '{ "range": { "ipubdate": {' +
            sbegindate +
            " , " +
            senddaate +
            "  }}  } ";
        }
        searchfilter = global.addcomma(searchfilter, spubdatefilter);
      }

      searchfilter = global.addcomma(treefilter, searchfilter);

      var sscopefilter = "";
      var myDate = new Date();
      if (this.scope == 0) {
      } else if (this.scope == 1) {
        myDate.setDate(myDate.getDate() - 1);
      } else if (this.scope == 2) {
        myDate.setDate(myDate.getDate() - 7);
      } else if (this.scope == 3) {
        myDate.setDate(myDate.getDate() - 30);
      }

      if (this.scope == 0) {
      } else {
        sscopefilter =
          '{"range": {"updateDate": {"gte": "' +
          global.dateFormat(myDate, "yyyy-mm-dd") +
          '"}}} ';
      }

      searchfilter = global.addcomma(searchfilter, sscopefilter);

      var strorder =
        '"from": ' +
        (this.ipageindex - 1) * this.ipagesize +
        ', "size": ' +
        this.ipagesize +
        ', "sort": [{"updateDate": {"order": "desc","unmapped_type": "keyword"}}]';

      var finfilter = "";
      if (searchfilter == "") {
        // finfilter = '"query": { "match_all": {} }';
        //增加日期过滤，否则日期错误的太多
        finfilter = '"query": { "range": { "ipubdate": {"lte": 20231231 }} }';
      } else {
        finfilter =
          ' "query": { "bool": { "filter": [ ' + searchfilter + " ] } }";
      }

      finfilter = "{" + finfilter + "," + strorder + "}";

      var objfilter = JSON.parse(finfilter);

      console.log("filter:" + finfilter);

      var stoken = window.localStorage.getItem("stoken");
      /*跨域请求开始*/
      let that = this;
      axios({
        headers: { "Content-type": "application/json", token: stoken },
        method: "post",
        // url: global.ssearskuip,
        url: global.sserverip + "getSkuByFilterFromES",
        data: JSON.stringify(objfilter),
        // auth: {
        //   username: "elastic",
        //   password: "ytbxUmIvzeYovWCDklFu",
        // },
      })
        .then(function (res) {
          console.log("res.data 111");
          console.log(res.data);
          that.iresultcount = res.data.hits.total.value;
          if (that.iresultcount >= 10000) {
            that.stooltip =
              '"抱歉：因为本次查询结果过于庞大，所以仅显示最新的一万条。"';
          } else {
            that.stooltip = "";
          }

          //罗列key，很有用，不要删！！！
          // for(var key in res.data.hits){console.log("Key是:" + key); }

          that.tableData = res.data.hits.hits;

          that.tableData.forEach((column, index) => {
            that.tableData[index]._source.supdateDate = global.dateFormat(
              that.tableData[index]._source.updateDate,
              "yyyy-mm-dd hh:mm:ss"
            );
          });

          console.log(that.tableData);

          that.show = false;
        })
        .catch(function (err) {
          console.log(err);
          that.show = false;
        });
      /*跨域请求结束*/
      //   } else {
      //     alert("认证超时过期");
      //     this.$router.replace("/");
      //   }
      // }
    },
  },
};
</script>


<style>
</style>
